// @flow
import React from 'react';
import styled from 'styled-components';
import { black } from '../../../colors';
import TabGroup, { TabGroupTheme } from '../../group';
var GroupBorderBottom = styled.div.withConfig({
  displayName: "group__GroupBorderBottom",
  componentId: "sc-1vl69sx-0"
})(["height:1px;background:linear-gradient(to left,transparent,", ");"], black());
var TabGroupEx = Object.assign({}, TabGroupTheme, {
  Main: styled(TabGroupTheme.Main).withConfig({
    displayName: "group__Main",
    componentId: "sc-1vl69sx-1"
  })(["display:flex;flex-direction:column;"])
});
var GroupTitle = styled.div.withConfig({
  displayName: "group__GroupTitle",
  componentId: "sc-1vl69sx-2"
})(["text-transform:uppercase;"]);
var GroupTabs = styled.div.withConfig({
  displayName: "group__GroupTabs",
  componentId: "sc-1vl69sx-3"
})(["display:flex;"]);
/*::
import type { Node } from 'react';

type GroupPropsType = {|
  title: string,
  children?: Node,
  rest?: any,
|};
*/

var Group = function Group(_ref
/*: GroupPropsType */
) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(TabGroup, {
    theme: TabGroupEx
  }, /*#__PURE__*/React.createElement(GroupTitle, null, title), /*#__PURE__*/React.createElement(GroupBorderBottom, null), /*#__PURE__*/React.createElement(GroupTabs, null, children));
};

export default Group;